<template><div><h1 id="import-zuordnung-adressimport-verarbeiten" tabindex="-1"><a class="header-anchor" href="#import-zuordnung-adressimport-verarbeiten"><span>Import Zuordnung (Adressimport verarbeiten)</span></a></h1>
<p>Import Zuordnung (Adressimport verarbeiten) — Manuelle Zuordnung von Adressen nach dem Datenimport</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Der <RouteLink to="/referenz/refs/ft.refdata.adrimpzuo.html" title="Adressimport mit manueller Zuordnung">Adressimport mit manueller Zuordnung</RouteLink> verarbeitet alle Datensätze automatisch, die ohne Abweichung einer vorbestehnden Person in funtrade zugeordnet werden können. Die verbleibenden Datensätze werden in diesem Frame manuell neu erfasst oder einer bestehenden Person zugeordnet.</p>
<p>Der Grundsätzliche Ablauf ist wie folgt:</p>
<ol>
<li>
<p><RouteLink to="/referenz/refs/ft.refdata.adrimpzuo.html" title="Adressimport mit manueller Zuordnung">Import</RouteLink> erfassen und starten</p>
</li>
<li>
<p>Personen manuell erfassen und zuordnen</p>
</li>
<li>
<p>Daten verabeiten</p>
</li>
</ol>
<p>Pfad: <code v-pre>Datenaustausch → Adressimport mit manueller Zuordnung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Person</dt>
<dd>Name und Adresse aus der Quelldatei</dd>
<dt>Status</dt>
<dd>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>OK</td>
<td>Datensatz ist OK und kann neu in funtrade angelegt werden</td>
</tr>
<tr>
<td>Fehler</td>
<td>Daten in der Quelldatei können nicht fehlerfrei verarbeitet werden (z.B. postalisch inkorrekt oder zuordbare Person ist Dublette). In diesem Fall wird die Fehlermeldung im Subframe angezeigt.</td>
</tr>
<tr>
<td>zugeordnet</td>
<td>Datensatz ist automatisch oder manuell zugeordnet worden</td>
</tr>
<tr>
<td>abgelehnt</td>
<td>Datensatz ist manuell abgelehnt worden</td>
</tr>
<tr>
<td>verarbeitet</td>
<td>Datensatz ist vollständig eingelesen und verarbeitet</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="person-erfassen-und-zuordnen" tabindex="-1"><a class="header-anchor" href="#person-erfassen-und-zuordnen"><span>Person erfassen und zuordnen...</span></a></h3>
<p>Diese Funktion kommt zum Einsatz, wenn keine Person für eine Zuordnung vorgeschlagen wird. Beim Start wird die Personen-Erfassungsmaske geöffnet nach Eingabe/Bestätigung der Personendaten die Zuordnung gemacht. Ansonsten erfolgt die Zuordnung direkt auf den vorgeschlagenen Personen.</p>
<h3 id="person-ablehnen" tabindex="-1"><a class="header-anchor" href="#person-ablehnen"><span>Person ablehnen...</span></a></h3>
<p>Entfernt die eingelesenen Adressdaten. Zurücksetzen ist nur möglich, wenn noch keine Daten verarbeitet worden sind (Status=&quot;eingelesen, noch nicht verarbeitet&quot;).</p>
<h3 id="import-zuordnung" tabindex="-1"><a class="header-anchor" href="#import-zuordnung"><span>Import Zuordnung</span></a></h3>
<p>Nach dem Import der Adressdaten können nicht zuordbare Adressen manuell verknüpft werden. Dies geschieht im Tab <RouteLink to="/referenz/refs/ft.refdata.importverarbeiten.html" title="Import Zuordnung (Adressimport verarbeiten)">Import Zuordnung (Adressimport verarbeiten)</RouteLink>.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrimpzuo.html" title="Adressimport mit manueller Zuordnung">Adressimport mit manueller Zuordnung</RouteLink></p>
</div></template>


